'use strict';

const VERSION = '1.0.0';
const NAME = 'calendar';

require('../../../_shared/globals/calendar-helper');

let defaultConfig = {
    rows: 6,
    cols: 7,
    workingSaturday: true,
    workingSunday: true,
    freeDays: [],
};

let i18n = {
    ro: {
        todayText: 'Azi',
        monthNames: ['Ianuarie','Februarie','Martie','Aprilie','Mai','Iunie',
            'Iulie','August','Septembrie','Octombrie','Noiembrie','Decembrie'],
        monthNamesShort: ['Ian', 'Feb', 'Mar', 'Apr', 'Mai', 'Iun',
            'Iul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        dayNames: ['Duminică', 'Luni', 'Marţi', 'Miercuri', 'Joi', 'Vineri', 'Sâmbătă'],
        dayNamesShort: ['Dum', 'Lun', 'Mar', 'Mie', 'Joi', 'Vin', 'Sâm'],
        dayNamesMin: ['Du','Lu','Ma','Mi','Jo','Vi','Sâ'],
        legend: {
            title: "informații despre calendar",
            current_day: "zi curentă",
            selected_day: "zi selectată",
            closed_period: "nu se poate livra",
            full_day: "zi ocupată total",
            grouped_days: "zile pachet",
            weekend: "weekend",
            unavailable: "zi indisponibilă"
        }
    },
    en: {
        todayText: 'Today',
        monthNames: ['January','February','March','April','May','June',
            'July','August','September','October','November','December'],
        monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Satruday'],
        dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fru', 'Sat'],
        dayNamesMin: ['Su','Mo','Tu','We','Th','Fr','Sa'],
        legend: {
            title: "about calendar",
            current_day: "current day",
            selected_day: "selected day",
            closed_period: "no delivery",
            full_day: "full day",
            grouped_days: "grouped days",
            weekend: "weekend",
            unavailable: "unavailable"
        }
    }
}

function Calendar(calendarContainer, options = {}, callback = (selectedDate, selectedDateString) => {}) {
    // require('../../../_shared/globals/calendar-helper');

    let language = options.language || 'en';
    this.config = {};
    this.config = Object.assign(this.config, defaultConfig);
    this.config = Object.assign(this.config, options);
    this.config.language = language;
    this.translation = i18n[language];
    
    this.callback = callback;

    this.days = [];
    this.selected = {start: null, end: null};
    this.selectedDate = null;
    this.selectedCity = options.selectedCity || {};
    if (options.selectedDate) {
        this.selectedDate = CalendarHelperSingleton.dateStringToDate(options.selectedDate);
        this.addDate(this.selectedDate);
    }

    console.log('CalendarHelperSingleton.update', this.config, this.selectedCity)
    CalendarHelperSingleton.update(this.config, this.selectedCity);
    
    this.today = new Date();
    this.todayZero = new Date();
    this.todayZero.setUTCHours(0, 0, 0, 0);
    this.tomorrow = new Date(this.today.getTime() + (24 * 60 * 60 * 1000));
    this.tomorrowZero = new Date(this.today.getTime() + (24 * 60 * 60 * 1000));
    this.tomorrowZero.setUTCHours(0, 0, 0, 0);
    this.maxDay = new Date(this.today.getTime() + (90 * 24 * 60 * 60 * 1000));
    this.maxDayZero = new Date(this.today.getTime() + (90 * 24 * 60 * 60 * 1000));
    this.maxDayZero.setUTCHours(0, 0, 0, 0);
    this.selectedMonthYear = new Date();
    this.selectedMonthYear.setUTCDate(1);
    this.selectedMonthYear.setUTCHours(0, 0, 0, 0);
    this.datesAdded = 0;
    
    this.calendarContainer = calendarContainer;
    console.log(this.calendarContainer);

    this.inputSelectedDate = this.calendarContainer.querySelector("input[type='hidden'][name='date']");

    this.element = this.calendarContainer.querySelector(".calendar");
    console.log(this.element);
    this.title = this.element.querySelector(".title");
    this.content = this.element.querySelector(".content");
    console.log(this.content);
    this.nav = new CalendarNav(this, this.element.querySelector(".nav"));
    this.legend = new CalendarLegend(this, this.element.querySelector(".legend"), language);

    this.resetContent();
    this.goTodayFirstTime(this);
}

Calendar.prototype.populate = function () {
    let firstDayInMonth = this.selectedMonthYear.getUTCDay();
    let startDate = new Date(this.selectedMonthYear.getTime() - ((firstDayInMonth + 6) * 24 * 60 * 60 * 1000));
    startDate.setUTCHours(0,0,0,0);

    let lastDate = new Date(startDate.getTime() - (24 * 60 * 60 * 1000));

    let prevMonth = new Date();
    prevMonth.setUTCMonth(this.selectedMonthYear.getUTCMonth() - 1, 1);
    let nextMonth = new Date();
    nextMonth.setUTCMonth(this.selectedMonthYear.getUTCMonth() + 1, 1);
    this.title.innerHTML = this.translation.monthNames[this.selectedMonthYear.getUTCMonth()] + ' ' + this.selectedMonthYear.getUTCFullYear();

    this.nav.prev.innerHTML = this.translation.monthNames[prevMonth.getUTCMonth()];
    this.nav.next.innerHTML = this.translation.monthNames[nextMonth.getUTCMonth()];
    this.nav.today.innerHTML = this.translation.todayText;

    this.days = [];
    // $('#calendar-debug').html('');

    for (let i = 0; i < this.config.rows * this.config.cols; i++) {
        let dayDate = new Date(startDate.getTime() + i * 24 * 60 * 60 * 1000);
        dayDate.setUTCHours(0,0,0,0);

        //$('#calendar-debug').append(dayDate + ' => dateIsInClosedPeriod = ' + dateIsInClosedPeriod(dayDate)  + ' => dateIsInFullBookedPeriod = ' + dateIsInFullBookedPeriod(dayDate)  + ' => dateIsInGroupBookedPeriod = ' + dateIsInGroupBookedPeriod(dayDate) + '<br />');

        this.days.push(dayDate);
        let d = document.getElementById('day' + i);
        // d.innerHTML = '<strong>' + this.translation.dayNamesShort[dayDate.getUTCDay()] + '</strong>' + dayDate.getUTCDate() + '<i>' + this.translation.monthNamesShort[dayDate.getUTCMonth()] + '</i>';
        d.innerHTML = `
        <span class="weekday">${this.translation.dayNamesShort[dayDate.getUTCDay()]}</span>
        <span class="day">${dayDate.getUTCDate()}</span>
        <span class="month">${this.translation.monthNamesShort[dayDate.getUTCMonth()]}</span>
        `;
        //d.innerHTML = '<strong>' + calendar.dayNames[dayDate.getUTCDay()] + '</strong><br />' + dayDate.getUTCDate() + '<i>' + calendar.monthNamesShort[dayDate.getUTCMonth()] + '</i>';
        //d.innerHTML = dayDate;

        d.setAttribute('class','');
        if (dayDate < this.todayZero) {
            d.setAttribute('class','disabled');
        } else if (dayDate > this.maxDayZero) {
            d.setAttribute('class','disabled');
        } else {
            let _dateIsToday = dayDate.getTime() === this.todayZero.getTime();
            let _dateIsInWeekend = CalendarHelperSingleton.dateIsInWeekend(dayDate);
            let _dateIsInClosedPeriod = false;
            let _dateIsInFullBookedPeriod = false;
            let _dateIsInGroupBookedPeriod = false;
            let _dateIsInFreeDays = CalendarHelperSingleton.dateIsInFreeDays(dayDate);

            if (_dateIsToday) {
                d.setAttribute('class','today');
            }
            if (_dateIsInWeekend) {
                d.setAttribute('class','weekend');
            }
            if (_dateIsInClosedPeriod) {
                d.setAttribute('class','closed');
            }
            if (_dateIsInFullBookedPeriod) {
                d.setAttribute('class','booked');
            }
            if (_dateIsInGroupBookedPeriod) {
                d.setAttribute('class','grouped');
            }
            if (_dateIsInFreeDays) {
                d.setAttribute('class','closed');
            }

            if (this.selected.start && this.selected.end) {
                if (this.selected.start.getTime() <= dayDate.getTime() && dayDate.getTime() <= this.selected.end.getTime()) {
                    d.setAttribute('class','selected');
                }
            }

            //force recheck
            if (_dateIsToday && !this.selectedCity.hasSameDayDelivery) {
                d.setAttribute('class','closed');
            }
            if (_dateIsInClosedPeriod) {
                d.setAttribute('class','closed');
            }
            if (_dateIsInFullBookedPeriod) {
                d.setAttribute('class','booked');
            }
            if (_dateIsInFreeDays) {
                d.setAttribute('class','closed');
            }
        }
    }
}

Calendar.prototype.goTodayFirstTime = function (calendar) {
    calendar.selectedMonthYear = new Date();
    calendar.selectedMonthYear.setUTCDate(1);
    calendar.selectedMonthYear.setUTCHours(0, 0, 0, 0);
    calendar.populate();
}
Calendar.prototype.goToday = function (calendar) {
    calendar.selectedMonthYear = new Date();
    calendar.selectedMonthYear.setUTCDate(1);
    calendar.selectedMonthYear.setUTCHours(0, 0, 0, 0);
    calendar.populate();
}
Calendar.prototype.nextMonth = function (calendar) {
    calendar.selectedMonthYear.setUTCMonth(calendar.selectedMonthYear.getUTCMonth() + 1, 1);
    calendar.populate();
}
Calendar.prototype.prevMonth = function (calendar) {
    calendar.selectedMonthYear.setUTCMonth(calendar.selectedMonthYear.getUTCMonth() - 1, 1);
    calendar.populate();
}


Calendar.prototype.calendarClick = function (event, calendar) {
    let target = event.target;
    let id;
    if (!target.id) {
        target = target.parentNode;
    }
    id = Number(target.id.replace(/day/gi, ''));
    let date = calendar.days[id];

    // console.log('calendarClick', date);

    if (date.getTime() < calendar.todayZero.getTime()) return;

    calendar.addDate(date);

    if (!CalendarHelperSingleton.isDateAvailable(date, calendar.config, calendar.selectedCity)) return;
    calendar.populate();

    calendar.selectedDate = date;
    if (calendar.inputSelectedDate) {
        calendar.inputSelectedDate.value = CalendarHelperSingleton.dateToString(calendar.selectedDate);
    }
    if (calendar.callback) {
        calendar.callback(calendar.selectedDate, CalendarHelperSingleton.dateToString(calendar.selectedDate));
    }
};

Calendar.prototype.updateDeliveryCity = function (deliveryCity = {}) {
    // this.element.removeAttribute('style');
    this.element.style.display = 'block';
    this.selectedCity = deliveryCity;
    this.populate();
};

Calendar.prototype.addDate = function (date) {
    this.selected.start = date;
    this.selected.end = date;
    this.datesAdded = 0;
};

Calendar.prototype.resetContent = function () {
    let day = 0;

    console.log(this);
    console.log(this.content);
    this.content.innerHTML = '';

    let self = this;

    for (let i = 0; i < this.config.rows; i++) {
        let ul = document.createElement('ul');
        for (let j = 0; j < this.config.cols; j++) {
            let li = document.createElement('li');
            li.setAttribute('id',`day${day}`);
            li.innerHTML = `${day}`;
            li.onclick = (event) => {
                self.calendarClick(event, this);
            };
            ul.appendChild(li);
            day++;
        }
        this.content.appendChild(ul);
    }
};

function CalendarNav(calendar, element) {
    this.calendar = calendar;
    this.element = element;
    
    this.today = document.querySelector(".today");
    this.prev = document.querySelector(".prev");
    this.next = document.querySelector(".next");

    this.today.onclick = () => {
        calendar.goToday(calendar);
    };
    this.prev.onclick = () => {
        calendar.prevMonth(calendar);
    };
    this.next.onclick = () => {
        calendar.nextMonth(calendar);
    };
}

function CalendarLegend(calendar, element, language = 'en') {
    this.calendar = calendar;
    this.element = element;

    this.title = this.element.querySelector(".title");

    this.today = this.element.querySelector(".today");
    this.selected = this.element.querySelector(".selected");
    this.closed = this.element.querySelector(".closed");
    this.booked = this.element.querySelector(".booked");
    this.grouped = this.element.querySelector(".grouped");
    this.weekend = this.element.querySelector(".weekend");
    this.disabled = this.element.querySelector(".disabled");

    let keys = 'title,today,selected,closed,booked,grouped,weekend,disabled'.split(',');
    let translationKeys = 'title,current_day,selected_day,closed_period,full_day,grouped_days,weekend,unavailable'.split(',');

    keys.forEach((key, i) => {
        if (this[key]) {
            this[key].innerHTML = this.calendar.translation.legend[translationKeys[i]];
        }
    });
}

module.exports = Calendar;